import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconClock = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0002 6.33325C8.87055 6.33325 6.3335 8.87031 6.3335 11.9999C6.3335 15.1295 8.87055 17.6666 12.0002 17.6666C15.1298 17.6666 17.6668 15.1295 17.6668 11.9999C17.6668 8.87031 15.1298 6.33325 12.0002 6.33325ZM4.3335 11.9999C4.3335 7.76574 7.76598 4.33325 12.0002 4.33325C16.2343 4.33325 19.6668 7.76574 19.6668 11.9999C19.6668 16.2341 16.2343 19.6666 12.0002 19.6666C7.76598 19.6666 4.3335 16.2341 4.3335 11.9999ZM11.0002 11.9999V7.99992H13.0002V11.3819L15.114 12.4388L14.2196 14.2277L11.5529 12.8943C11.2142 12.725 11.0002 12.3787 11.0002 11.9999Z"
        />
      </svg>
    );
  }
);
